// src/pages/Auth/UserLoginScreen.js
import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import { doc, getDocs, collection, query, where, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase';

function UserLoginScreen() {
  const [isRegister, setIsRegister] = useState(false);
  const [email, setEmail] = useState('');
  const [passord, setPassord] = useState('');
  const [tilgangskode, setTilgangskode] = useState('');
  const [feil, setFeil] = useState('');
  const navigate = useNavigate();

  const auth = getAuth();

  const loggInn = async () => {
    try {
      await setPersistence(auth, browserLocalPersistence);
      await signInWithEmailAndPassword(auth, email, passord);
      navigate('/myessence');
    } catch (error) {
      console.error('❌ Feil ved innlogging:', error);
      setFeil('⚠️ Feil e-post eller passord.');
    }
  };

  const registrerBruker = async () => {
    try {
      const kodeQuery = query(collection(db, 'accessCodes'), where('code', '==', tilgangskode), where('used', '==', false));
      const snapshot = await getDocs(kodeQuery);

      if (snapshot.empty) {
        setFeil('❌ Ugyldig eller brukt tilgangskode.');
        return;
      }

      const kodeDoc = snapshot.docs[0];
      await createUserWithEmailAndPassword(auth, email, passord);

      // Marker koden som brukt
      await updateDoc(doc(db, 'accessCodes', kodeDoc.id), {
        used: true,
        usedBy: email,
        timestampUsed: new Date()
      });

      navigate('/create-essens');
    } catch (error) {
      console.error('❌ Feil ved registrering:', error);
      setFeil('⚠️ Kunne ikke registrere bruker.');
    }
  };

  const handleSubmit = () => {
    setFeil('');
    isRegister ? registrerBruker() : loggInn();
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white px-4">
      <h1 className="text-2xl font-bold mb-6">
        {isRegister ? '🆕 Opprett ny bruker' : '🔐 Brukerinnlogging'}
      </h1>

      <input
        type="email"
        placeholder="E-post"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="mb-4 px-4 py-2 rounded w-72 text-black"
      />

      <input
        type="password"
        placeholder="Passord"
        value={passord}
        onChange={(e) => setPassord(e.target.value)}
        className="mb-4 px-4 py-2 rounded w-72 text-black"
      />

      {isRegister && (
        <input
          type="text"
          placeholder="Tilgangskode"
          value={tilgangskode}
          onChange={(e) => setTilgangskode(e.target.value)}
          className="mb-4 px-4 py-2 rounded w-72 text-black"
        />
      )}

      <button
        onClick={handleSubmit}
        className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded"
      >
        {isRegister ? 'Registrer deg' : 'Logg inn'}
      </button>

      {feil && <p className="text-red-500 mt-4">{feil}</p>}

      <p className="mt-6 text-sm text-gray-400 cursor-pointer underline" onClick={() => {
        setIsRegister(!isRegister);
        setFeil('');
      }}>
        {isRegister ? 'Har du allerede en bruker? Logg inn her.' : 'Har du tilgangskode? Registrer deg her.'}
      </p>
    </div>
  );
}

export default UserLoginScreen;
